  /* default config file for farmx frontend */
    let testMode = false

    export default {
  /* IMPORTANT NOTE: api requires slash at the end of the url! Example: 'https://exampleapi.example.ch/' */
    /* Other apis (eg. billing api) don't need slashes at the end of the url! */

    // LOCALHOST
    // api: 'http://localhost:3000/',
    // billingApi: 'http://localhost:3000/pdf',
    // imageApi: 'http://localhost:3000/images',
    // imageUploadApi: 'http://localhost:3000/upload/picture',
    // frontendBaseUrl: 'http://localhost:8080/',

    // DEV
    // api: 'https://devapi.farmx.ch/',
    // billingApi: 'https://devd.farmx.ch/pdf',
    // imageApi: 'https://devd.farmx.ch/images',
    // imageUploadApi: 'https://devapi.farmx.ch/upload/picture',
    // frontendBaseUrl: 'devapp.farmx.ch/',

    // PROD
    // api: 'https://api.farmx.ch/',
    // billingApi: 'https://d.farmx.ch/pdf',
    // imageApi: 'https://d.farmx.ch/images',
    // imageUploadApi: 'https://api.farmx.ch/upload/picture',
    // frontendBaseUrl: 'https://farmx.ch/',

    // DEV
  api: 'https://devapi.farmx.ch/',
  billingApi: 'https://devd.farmx.ch/pdf',
  imageApi: 'https://devd.farmx.ch/images',
  imageUploadApi: 'https://devapi.farmx.ch/upload/picture',
  frontendBaseUrl: 'https://devapp.farmx.ch/',
  wordpressBaseUrl: 'https://info.farmx.ch/wp-json/wp/v2',
  sentryDSN: 'https://79503fccc214403481c1ed6b53811f5e@sentry.seccom.ch/6',
  sentrySR: 1.0,

                     /**
                     * Access rights
                     */
                       user: {
                         employee: 50,
                         normal: 15,
                         office: 10,
                         support: 5,
                         admin: 0
                       },

                     /**
                     * Timezone: Force application to use this timezone with moment.js
    */
                       timezone: 'Europe/Zurich',

                     /**
                     * Google reCaptcha
                     */
                       recaptcha: {
                         sitekey: ''
                       },

    // get random number in test
    getRecaptchaCode () {
  return testMode ? '1234' : null
  },

    // set default standard vat id for dropdown => id from database
  standardVatId: 1
  }
